import { render, staticRenderFns } from "./Kapcsolat.html?vue&type=template&id=5ee2ae59&"
import script from "./Kapcsolat.js?vue&type=script&lang=js&"
export * from "./Kapcsolat.js?vue&type=script&lang=js&"
import style0 from "./Kapcsolat.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports